import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SPECIALTIES } from "../../data/specialties";

export const Specialities = () => {
    const { t } = useTranslation();

    return (
        <section
            id="specialities"
            data-testid="specialities-section"
            className="relative py-20 md:py-28 bg-stone-50/60 border-y border-stone-200/70"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-3xl mb-14">
                    <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-3">
                        {t("specialities.eyebrow")}
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 leading-[1.05]">
                        {t("specialities.title")}
                    </h2>
                    <p className="mt-5 text-stone-600 text-base md:text-lg">
                        {t("specialities.subtitle")}
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-stone-200 rounded-3xl overflow-hidden">
                    {SPECIALTIES.map((s) => {
                        const Icon = s.icon;
                        // i18n key fallback to data-defined shortName
                        const translatedLabel = t(`specialities.${s.slug}`, {
                            defaultValue: s.shortName,
                        });
                        return (
                            <Link
                                key={s.slug}
                                to={`/specialties/${s.slug}`}
                                data-testid={`speciality-${s.slug}`}
                                className="bg-white p-6 md:p-8 flex flex-col items-start gap-4 group hover:bg-brand-50/60 transition-colors min-h-[180px]"
                            >
                                <div className="h-12 w-12 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center group-hover:bg-brand-700 group-hover:text-white transition-colors">
                                    <Icon className="h-6 w-6" />
                                </div>
                                <div className="font-display text-base md:text-lg font-semibold text-stone-900 leading-tight group-hover:text-brand-700">
                                    {translatedLabel}
                                </div>
                                <div className="mt-auto text-[11px] font-semibold text-brand-700 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                                    Explore →
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
